module.exports = __webpack_public_path__ + "img/slider.5a193694.png";